<div matDialogContainer>
  @if (!modalOptions().disableHeader) {
    <div class="fw-semibold ps-3" mat-dialog-title>
      @switch (type()) {
        @case (modalType.ALERT) {
          <span>
            {{ modalOptions().title || 'Attenzione' }}
          </span>
        }
        @case (modalType.SUCCESS) {
          <span>
            {{ modalOptions().title || 'Successo' }}
          </span>
        }
        @default {
          <span>
            {{ modalOptions().title }}
          </span>
        }
      }
    </div>
  }
  <div mat-dialog-content [ngClass]="{ 'fs-6': modalOptions().disableHeader }">
    <span>
      @switch (type()) {
        @case (modalType.ALERT) {
          <span>
            {{ modalOptions().message || 'Si è verificato un errore bloccante.' }}
          </span>
        }
        @case (modalType.SUCCESS) {
          <span>
            {{ modalOptions().message || '' }}
          </span>
        }
        @case (modalType.CONFIRM) {
          <span>
            {{ modalOptions().message || 'Azione richiesta' }}
          </span>
          @if (showDateEventoField) {
            <div class="mt-3 w-full md:w-[320px]">
              <siat-datepicker-field
                [formGroup]="dataEventoForm"
                controlName="dataEvento"
                [maxDate]="today"
                label="Data evento"
                placeholder="Seleziona data evento"
              ></siat-datepicker-field>
            </div>
          }
        }
        @case (modalType.ACTION) {
          <span>
            {{ modalOptions().message || 'Azione richiesta' }}
          </span>
          <siat-checkbox-field
            [formGroup]="checkActionForm"
            controlName="flag"
            id="flag"
            name="flag"
            [label]="modalOptions().checkLabel"
            class="col-span-full"
          >
          </siat-checkbox-field>
        }
        @default {
          <span>
            {{ modalOptions().message }}
          </span>
        }
      }
    </span>
  </div>
  <div matDialogActions>
    @if (type() === modalType.CONFIRM) {
      <button
        type="button"
        matButton="outlined"
        class="mr-3"
        (click)="closeModal(modalAction.DISMISSED)"
      >
        {{ modalOptions().dismissButtonLabel || 'Annulla' }}
      </button>
    }
    <button
      matButton="filled"
      type="submit"
      [disabled]="showDateEventoField && dataEventoForm.invalid"
      (click)="closeModal(modalAction.CONFIRMED)"
    >
      @switch (type()) {
        @case (modalType.ALERT || modalType.INFO) {
          {{ modalOptions().closeButtonLabel || 'Ok, ho capito' }}
        }
        @case (modalType.SUCCESS) {
          {{ modalOptions().closeButtonLabel || 'Prosegui' }}
        }
        @case (modalType.CONFIRM || modalType.ACTION) {
          {{ modalOptions().closeButtonLabel || 'Conferma' }}
        }
        @default {
          {{ modalOptions().closeButtonLabel }}
        }
      }
    </button>
  </div>
</div>
